// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerShipToAddressStyles } from "@synd/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, getSystemColor, layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.drawer = {
    ...headerShipToAddressStyles.drawer,
    closeButtonProps: {
        ...headerShipToAddressStyles.drawer?.closeButtonProps,
        variant: "link" as any,
        css: css`
            &&&&&:not(:disabled) {
                &,
                & ${ButtonIcon} {
                    color: ${color("common.ui6")};
                }
            }
            &&&&:not(:disabled):hover ${ButtonIcon} {
                color: ${color("common.ui10")};
            }
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
    },
    cssOverrides: {
        drawerTitle: css`
            background: ${color("common.background")};
            ${layoutContainer}
            width: 100%;
        `,
        drawerContent: css`
            height: 100%;
            overflow-y: unset;
            ${layoutContainer}
            width: 100%;
        `,
        drawerBody: css`
            background: ${color("common.background")};
            height: auto;
            max-height: 500px;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
        headlineTypography: css`
            margin: 0;
        `,
    },
};

headerShipToAddressStyles.titleTypography = {
    ...headerShipToAddressStyles.titleTypography,
    transform: undefined,
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.semiBold,
    css: css`
        margin-right: 4px;
        ${xScreen("lte", "md")} {
            margin: 0;
            color: ${color("common.ui6")};
            font-size: ${fontConfig.smallSingleLine.size}px;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
        }
    `,
};

headerShipToAddressStyles.shipToToolTip = {
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin: 0;
                & ${TypographyStyle} {
                    max-width: 157px;
                    display: block;
                }
                ${xScreen("lte", "md")} {
                    &,
                    & ${TypographyStyle} {
                        max-width: 100%;
                    }
                }
            `,
        },
    },
};

headerShipToAddressStyles.fulfillmentAddressValue = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    color: getSystemColor("common.ui1"),
    ellipsis: true,
    css: css`
        text-align: left;
        ${xScreen("lte", "md")} {
            margin-left: 0;
            color: ${color("common.ui6")};
            font-size: ${fontConfig.smallSingleLine.size}px;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
        }
    `,
};

headerShipToAddressStyles.fulfillmentSeparator = {
    size: 17,
    css: css`
        color: ${color("common.ui3")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        padding: 8px 0;
        max-width: 100%;
        width: auto;
        display: inline-flex;
        text-align: left;
        align-items: center;
        ${xScreen("lte", "md")} {
            padding: 0;
            margin: 0;
            align-items: flex-start;
            flex-direction: column;
            gap: 8px;
        }
    `,
};
headerShipToAddressStyles.titleClickable = {
    css: css`
        gap: 6px;
        color: ${color("common.ui1")};
        &:not(:disabled):hover {
            ${TypographyStyle}, ${IconWrapper} {
                color: ${color("common.ui10")};
            }
        }
    `,
};

headerShipToAddressStyles.clickableIcon = {
    size: 12,
    css: css`
        font-weight: ${fontConfig.weight.light};
        color: ${color("common.ui1")};
        ${xScreen("lte", "md")} {
            color: ${color("primary.main")};
        }
    `,
};

headerShipToAddressStyles.clickableText = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        ${xScreen("lte", "md")} {
            color: ${color("primary.main")};
        }
    `,
};
